export default "__VITE_ASSET__Dl76YFjV__"